import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PortfolioMasterPage.css';
import './StrategyTable.css';
import { API_BASE_URL } from '../services/api';

const initialState = {
  strategy_id: '',
  portfolio_name: '',
  strategy_type: '',
  entity_business_unit: '',
};

const STRATEGY_TYPES = ['Trading', 'Investment', 'Liquidity'];
const ENTITY_UNITS = ['Finance', 'Marketing'];

function StrategyMasterPage() {
  const [form, setForm] = useState(initialState);
  const [strategies, setStrategies] = useState([]);
  const [editing, setEditing] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [portfolioOptions, setPortfolioOptions] = useState([]);

  useEffect(() => {
    fetchStrategies();
    fetchPortfolioNames();
  }, []);

  const fetchStrategies = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/strategy-master`);
      setStrategies(res.data);
    } catch (err) {
      console.error('Error fetching strategies:', err);
      setError('Failed to load strategies');
    }
  };

  const fetchPortfolioNames = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/portfolio-master`);
      setPortfolioOptions(res.data.map(p => p.portfolio_name));
    } catch (err) {
      console.error('Error fetching portfolio names:', err);
      setPortfolioOptions([]);
    }
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      if (editing) {
        await axios.put(`${API_BASE_URL}/strategy-master/${form.strategy_id}`, form);
        setSuccess('Strategy updated');
      } else {
        await axios.post(`${API_BASE_URL}/strategy-master`, form);
        setSuccess('Strategy created');
      }
      setForm(initialState);
      setEditing(false);
      fetchStrategies();
    } catch (err) {
      console.error('Error saving strategy:', err);
      setError('Error saving strategy');
    }
  };

  const handleEdit = s => {
    setForm(s);
    setEditing(true);
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this strategy?')) return;
    try {
      await axios.delete(`${API_BASE_URL}/strategy-master/${id}`);
      fetchStrategies();
    } catch (err) {
      console.error('Error deleting strategy:', err);
      setError('Error deleting strategy');
    }
  };

  return (
    <div className="page-container ui-page">
      <h2 style={{ color: '#222', textAlign: 'center', marginBottom: '1.5rem' }}>Strategy Master</h2>
      <form className="form-section compact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label style={{ color: '#222', fontWeight: 500 }}>Strategy ID</label>
            <input name="strategy_id" value={form.strategy_id} onChange={handleChange} required disabled={editing} />
          </div>
          <div className="form-group">
            <label style={{ color: '#222', fontWeight: 500 }}>Portfolio Name</label>
            <select name="portfolio_name" value={form.portfolio_name} onChange={handleChange} required>
              <option value="">Select</option>
              {portfolioOptions.map(name => (
                <option key={name} value={name}>{name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label style={{ color: '#222', fontWeight: 500 }}>Strategy Type</label>
            <select name="strategy_type" value={form.strategy_type} onChange={handleChange} required>
              <option value="">Select</option>
              {STRATEGY_TYPES.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label style={{ color: '#222', fontWeight: 500 }}>Entity/Business Unit</label>
            <select name="entity_business_unit" value={form.entity_business_unit} onChange={handleChange} required>
              <option value="">Select</option>
              {ENTITY_UNITS.map(unit => (
                <option key={unit} value={unit}>{unit}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-row">
          <button type="submit" className="save-verify-button">{editing ? 'Update' : 'Create'} Strategy</button>
          {editing && <button type="button" className="action-button" onClick={() => { setForm(initialState); setEditing(false); }}>Cancel</button>}
        </div>
      </form>
      <div style={{ marginTop: 20 }}>
        {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
        {success && <div style={{ color: 'green', marginBottom: 10 }}>{success}</div>}
        <table className="custom-table">
          <thead>
            <tr>
              <th>Strategy ID</th>
              <th>Portfolio Name</th>
              <th>Strategy Type</th>
              <th>Entity/Business Unit</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {strategies.map(s => (
              <tr key={s.strategy_id}>
                <td>{s.strategy_id}</td>
                <td>{s.portfolio_name}</td>
                <td>{s.strategy_type}</td>
                <td>{s.entity_business_unit}</td>
                <td>
                  <button className="action-button" onClick={() => handleEdit(s)}>Edit</button>
                  <button className="action-button" style={{ background: '#e57373' }} onClick={() => handleDelete(s.strategy_id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default StrategyMasterPage;
